module.exports = __webpack_public_path__ + "static/img/grid2.54a72d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/grid2.png
// module id = jcL6
// module chunks = 0